<template>
  <div id="addBucket" tabindex="-1" @keyup.esc="$parent.addBucket=false">
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$i18n.t('add')}}</h5>
            <button type="button" class="close" @click="$parent.addBucket=false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height:400px;">
            <form>
              <div class="form-group">
                <label for="nombre">{{$i18n.t('contenedor.name')}}</label>
                <input
                  type="text"
                  v-model="nombre"
                  class="form-control"
                  pattern="^[A-Za-z0-9_áéíóúàèìòùçÇ]+$"
                  required
                />
                <small class="form-text text-muted">{{$i18n.t('bucket.format.nombre')}}</small>
              </div>
              <div class="form-group">
                <label for="nota">{{$i18n.t('contenedor.note')}}</label>
                <input type="text" v-model="nota" class="form-control" />
              </div>
              <div class="row">
                <div class="col-sm" style="max-height:200px;">
                  <hr />
                  <h5>{{$i18n.t('recursos')}}</h5>
                  <form ref="fileform" class="fileform">
                    <span class="drop-files">{{$i18n.t("modal.drag-and-drop")}}</span>
                  </form>
                  <input
                    type="file"
                    class="w3-input"
                    @change="agregarArchivo"
                    multiple
                    ref="archivos"
                  />
                </div>
                <div class="col-sm" style="max-height:200px;overflow-y:auto">
                  <div v-for="(file, key) in recursos" class="file-listing" v-bind:key="key">
                    <img
                      :src="url(file)"
                      style="max-width:45px;max-height:45px;overflow-wrap: break-word;"
                    />
                    {{ file.name }}
                    <i
                      style="font-size:25px;color:red;cursor:pointer;float:right"
                      @click="recursos.splice(key, 1)"
                      class="fa fa-times"
                    ></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardar"
            >{{$i18n.t('save')}}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="$parent.addBucket=false"
            >{{$i18n.t('close')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "addBucket",
  data() {
    return {
      nombre: "",
      nota: "",
      recursos: [],
      _id: undefined,
      logError: []
    };
  },
  methods: {
    async guardar() {
      await this.crearBucket();
      await this.agregarRecursos();
      this.$router.push({
        name: "previewArticulo",
        params: { _id: this._id, lang: this.$i18n.locale }
      });
    },
    async crearBucket() {
      try {
        await this.axios
          .post(this.$store.getters.ws.api_recursos + "/buckets", {
            nombre: this.nombre,
            nota: this.nota,
            links: []
          })
          .then(r => {
            this._id = r.data._id;
          });
      } catch (err) {
        alert(err);
      }
    },
    async agregarRecursos() {
      if (this._id != undefined) {
        for (let file of this.recursos) {
          await this.realizarSuba(file);
        }
      }
    },
    agregarArchivo() {
      for (let i = 0; i < this.$refs.archivos.files.length; i++) {
        if (
          this.$refs.archivos.files[i].size <=
          this.$store.getters.ws.max_file_size_mb
        ) {
          this.$refs.archivos.files[i].tag = "";
          this.recursos.push(this.$refs.archivos.files[i]);
        } else
          alert(
            `No se pueden subir archivos con mas de ${this.$store.getters.ws
              .max_file_size_mb / 1000000}MB`
          );
      }
    },
    url(file) {
      if (file.type.includes("image")) {
        return URL.createObjectURL(file);
      } else if (file.name.toLowerCase().includes(".xls")) {
        return require("../img/xls.png");
      } else if (file.name.toLowerCase().includes(".pdf")) {
        return require("../img/pdf2.png");
      } else {
        return require("../img/noPreview.png");
      }
    },
    determineDragAndDropCapable() {
      /*
    Create a test element to see if certain events
    are present that let us do drag and drop.
  */
      var div = document.createElement("div");

      /*
    Check to see if the `draggable` event is in the element
    or the `ondragstart` and `ondrop` events are in the element. If
    they are, then we have what we need for dragging and dropping files.

    We also check to see if the window has `FormData` and `FileReader` objects
    present so we can do our AJAX uploading
  */
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    async vincular(_idRecurso) {
      try {
        await this.axios
          .post(
            this.$store.getters.ws.api_recursos +
              "/buckets/" +
              this._id +
              "/link/" +
              _idRecurso,
            {}
          )
          .then(() => {});
      } catch (err) {
        alert("No se pudo vincular");
      }
    },
    async realizarSuba(file) {
      try {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("labels", []);
        formData.append("descripcion", "Algo");
        let _idRecurso;
        await this.axios
          .post(this.$store.getters.ws.api_recursos + "/resources", formData)
          .then(p => {
            _idRecurso = p.data._id;
          });
        await this.vincular(_idRecurso);
      } catch (err) {
        if (err.response) {
          this.logError.push({
            archivo: file.name,
            error: err.response.data.exception
          });
        }
      }
    }
  },
  mounted() {
    /*
    Determine if drag and drop functionality is capable in the browser
  */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
    If drag and drop capable, then we continue to bind events to our elements.
  */
    if (this.dragAndDropCapable) {
      /*
      Listen to all of the drag events and bind an event listener to each
      for the fileform.
    */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
          this.$refs.fileform.addEventListener(
            evt,
            function(e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      /*
      Add an event listener for drop to the form
    */
      this.$refs.fileform.addEventListener(
        "drop",
        function(e) {
          /*
        Capture the files from the drop event and add them to our local files
        array.
      */
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            if (
              e.dataTransfer.files[i].size <=
              this.$store.getters.ws.max_file_size_mb
            ) {
              e.dataTransfer.files[i].tag = "";
              this.recursos.push(e.dataTransfer.files[i]);
            } else
              alert(
                "No se pueden subir archivos con mas de " +
                  this.$store.getters.ws.max_file_size_mb / 100000 +
                  "MB."
              );
          }
        }.bind(this)
      );
    }
  },
  created() {
    this.axios
      .get(this.$store.getters.ws.api_recursos + "/labels", {
        params: {
          size: 1000
        }
      })
      .then(json => {
        this.etiquetas = json.data.content.map(p => p.nombre);
      });
  }
};
</script>
<style>
#addBucket .fileform{
  max-height: 50px !important;
  margin-top:5px !important;
  text-align: center;
  line-height: 50px;
}
</style>